import React from 'react';



// Components
import Bread from '../components/Bread';
import FeatureComponent from '../components/Feature';

const Portfolio = () => {
  


  return (<>
    
      <Bread title="Our Features" des="We are team of talanted designers making Web and Native Apps" />
       <FeatureComponent/>
  
  </>);
}

export default Portfolio;
